import type { FeatureFlag } from '../../../shared/domain/status/types.no-deps'
import { DS_getData } from '../DS/DS.Data'

/**
 * Do not use this if you think you are getting feature flags from Launch Darkly. You probably want to be
 * using getFlagValue instead.
 *
 * It's just a hard coded array that the server syncs down to the app, so you can tell if the server
 * has been updated if it has got the new items in the array or not.
 */
export function Cust_hasFeature(feature: FeatureFlag) {
    const { featureFlags } = DS_getData()
    return featureFlags.includes(feature)
}
